import React from 'react';
import clsx from 'clsx';

import { Input } from '@auspost/postmaster-react';

import { SearchResult } from '../CalculatorModals/AddressLookupModal';
import { INLINE_EDD_INPUT_ERROR_TEST_ID, INLINE_EDD_SEARCH_INPUT_TEST_ID } from '../InlineEdd.test-ids';

import styles from '../InlineEdd.module.scss';

interface ManualPostcodeInputProps {
  handleInput: (eddQuery: SearchResult) => void;
}

const ManualPostcodeInput: React.FC<ManualPostcodeInputProps> = ({ handleInput }) => {
  const [manualInput, setManualInput] = React.useState('');
  const [error, setError] = React.useState('');

  const handleOnInput = (e: React.FormEvent<HTMLInputElement>) => {
    setError('');
    if (!e.currentTarget.checkValidity()) return;
    handleInput({ postcode: e.currentTarget.value });
  };

  const handleOnInvalid = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    setError('Please enter a valid postcode');
  };

  return (
    <>
      {error && (
        <span
          id='address-lookup-error'
          className={styles.errorLabel}
          role='alert'
          aria-atomic='true'
          data-testid={INLINE_EDD_INPUT_ERROR_TEST_ID}
        >
          {error}
        </span>
      )}
      <Input
        id='addressLookupInput'
        placeholder='Postcode'
        value={manualInput}
        pattern='\d{4}'
        className={clsx(styles.addressLookupInput, { [styles.error]: !!error })}
        data-testid={INLINE_EDD_SEARCH_INPUT_TEST_ID}
        required
        max={4}
        min={4}
        aria-describedby='address-lookup-error'
        onChange={(e) => setManualInput(e.target.value)}
        onInput={handleOnInput}
        onInvalid={handleOnInvalid}
      />
    </>
  );
};

export default ManualPostcodeInput;
